import * as React from "react";
import { useTranslation } from "react-i18next";
import {
Label,
Button,
Row,
Col,
Card,
CardBody,
Container,
Navbar,
CardHeader
} from "reactstrap";
import { AvForm, AvGroup, AvField } from "availity-reactstrap-validation";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import i18next from "i18next";

import { CzechFlag, USAFlag } from "../SidePanel";

const LoginPage = ({ handleSubmit, authentification }: any) => {
const { t } = useTranslation("admin");

const changeLanguage = (lang: any) => {
  i18next.changeLanguage(lang);
}


return (
<React.Fragment>
  <Container style={{ height: "80vh" }}>
    <Row style={{ alignItems: "center", margin: 0, height: "100%" }}>
      <Col sm="12" md={{ size: 6, offset: 3 }}>
      <Card>
        <CardHeader className="sypal-background">
          <h1 className="text-center" style={{textTransform: "uppercase", color: "white"}}>sypal</h1>
        </CardHeader>
        <CardBody style={{padding: "3rem 2rem 1rem 2rem"}}>
          <AvForm onValidSubmit={handleSubmit}>
            <AvGroup>
              <Label>{t("Email")}</Label>
              <AvField id="username" name="username" type="text" autoComplete="username" />
            </AvGroup>
            <AvGroup>
              <Label>{t("Password")}</Label>
              <AvField id="password" name="password" type="password" autoComplete="current-password" />
            </AvGroup>
            <Row style={{ justifyContent: "center", padding: "30px 0" }}>
              <Col style={{ textAlign: "center" }} sm="12" md="4">
              <Button color="success" className="w-100">
                {t("Login")}
              </Button>
              </Col>
            </Row>
          </AvForm>
        </CardBody>
      </Card>

      <Row className="justify-content-center pt-4">
        <Col md="4">
        <Row>
          <Col className="text-center" onClick={()=> changeLanguage("cs")}>
          <i className="p-0 m-auto">
            <CzechFlag />
          </i>
          </Col>
          <Col className="text-center" onClick={()=> changeLanguage("en")}>
          <i className="p-0 m-auto">
            <USAFlag />
          </i>
          </Col>
        </Row>
        </Col>
      </Row>
      </Col>
    </Row>
  </Container>
</React.Fragment>
);
};

const mapStateToProps = (state: any) => {
return {
authentification: state.authentification
};
};

const LoginPageComponent = connect(mapStateToProps)(LoginPage);

export { LoginPageComponent as LoginPage };